// Utils
import axios, { endpoints } from 'src/utils/axios';

const URL = endpoints.user_teams.root;

// ----------------------------------------------------------------------

export async function userTeamsGetAll(my_teams) {
  let sendUrl = URL;
  if(my_teams) {
    sendUrl += '?my_teams=true';
  }
  const response = await axios.get(sendUrl);
  return response.data;
}

export async function userTeamsGetByID(teamID) {
  const response = await axios.get(`${URL}/${teamID}`);
  return response.data;
}

export async function userTeamsCreate(data) {
  const response = await axios.post(URL, data);
  return response.data;
}

export async function userTeamsUpdate(teamID, data) {
  const response = await axios.put(`${URL}/${teamID}`, data);
  return response.data;
}

export async function userTeamsUpdateFile(teamID, file) {
  const bodyFormData = new FormData();
  bodyFormData.append('file', file);
  const response = await axios.put(`${URL}/${teamID}/file`, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
}

export async function userTeamsDeleteFile(teamID) {
  const response = await axios.delete(`${URL}/${teamID}/file`);
  return response.data;
}

export async function userTeamsUpdateStatus(teamID, data) {
  const response = await axios.put(`${URL}/${teamID}/status`, data);
  return response.data;
}